import {
  SidebarNavigationProvider,
  MobileNavigationProvider,
  CompanyScopeProvider,
} from '../../contexts';
import { Header, Sidebar, MobileSidebar } from '..';
import { Outlet, useLocation } from 'react-router-dom';
import { useScrollToTop } from '../../hooks';
import { memo } from 'react';

const Root: React.FC = memo(() => {
  useScrollToTop();
  const { pathname } = useLocation();
  const companyScopedPages = new Set([
    '/travel/home',
    '/travel/all',
    '/travel/approvals',
    '/travel/reports',
    '/contracts/home',
    '/contracts/all',
    '/contracts/approvals',
    '/contracts/reports',
  ]);
  const showCompanyScope = companyScopedPages.has(pathname);

  return (
    <CompanyScopeProvider enabled={showCompanyScope}>
      <SidebarNavigationProvider>
        <MobileNavigationProvider>
          <main className="w-full flex flex-row relative">
            <Sidebar />
            <MobileSidebar />
            <div className="flex flex-col w-full">
              <Header />
              <section className="main-content bg-white min-h-[90vh] flex-1">
                <Outlet />
              </section>
            </div>
          </main>
        </MobileNavigationProvider>
      </SidebarNavigationProvider>
    </CompanyScopeProvider>
  );
});

export default Root;
